import { render } from "./OrderInput.vue?vue&type=template&id=3f0c1e2c&scoped=true"
import script from "./OrderInput.vue?vue&type=script&lang=js"
export * from "./OrderInput.vue?vue&type=script&lang=js"

import "./OrderInput.vue?vue&type=style&index=0&id=3f0c1e2c&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0c1e2c"]])

export default __exports__